import { GenericError, LoadingSpinner } from '@psyomics/ui-components';
import { Navigate, useParams } from 'react-router-dom';

import { ReferralRequestStatus } from '../../../features/referral-request/generated/referral-request';
import { useReferralRequest } from '../../../features/referral-request/hooks/use-referral-request';
import { useReferralRequestService } from '../../../features/referral-request/hooks/use-referral-request-service';
import { ReferralRequestEdit as ReferralRequestEditFeature } from '../../../features/referral-request/referral-request-edit';

const useReferralRequestEditData = () => {
  const { id } = useParams<{ id: string }>();
  const { referralRequest, fetching: fetchingDraft } = useReferralRequest(id ?? '', ReferralRequestStatus.Draft);
  const { service, fetching: fetchingService } = useReferralRequestService(
    referralRequest?.organisationCode ?? '',
    referralRequest?.serviceCode ?? ''
  );

  return { referralRequest, fetching: fetchingDraft || fetchingService, id, service };
};

const ReferralRequestEdit = () => {
  const { referralRequest, fetching, id, service } = useReferralRequestEditData();

  if (!id) return <Navigate to="/" />;
  if (fetching) return <LoadingSpinner />;
  if (!referralRequest || !service) return <GenericError titleKey="common.errors.notFound" />;

  return <ReferralRequestEditFeature draftReferralRequest={referralRequest} id={id} service={service} />;
};

export { ReferralRequestEdit };
